import React from 'react'
import type { ToolbarProps } from 'react-big-calendar'
import { CalendarToolbar } from '../../CalendarToolbar'
import { useProductionCalendar } from '../ProductionCalendarContext'
import ProductionCalendarEstimatorSelect from './ProductionCalendarEstimatorSelect'

export function ProductionCalendarToolbar(props: ToolbarProps) {
  const { events, loading, date, setDate, tab, view, setView } = useProductionCalendar()
  const activeView = tab === 'map' ? view : props.view
  return (
    <CalendarToolbar
      {...props}
      events={events}
      date={date}
      setDate={setDate}
      tab={tab}
      view={activeView}
      setView={setView}
      loading={loading}
      EstimatorSelectComponent={<ProductionCalendarEstimatorSelect />}
      isProduction
    />
  )
}
